import { render } from "./upimgs.vue?vue&type=template&id=d4012a70"
import script from "./upimgs.vue?vue&type=script&lang=js"
export * from "./upimgs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__